export const MILLISECONDS_IN_A_MINUTE = 60 * 1000;
export const minutesAsMilliSeconds = (minutes: number): number =>
  minutes * MILLISECONDS_IN_A_MINUTE;
